import { EFillApplicationStickyButtonType } from '../../../containers/stickyButtons/FillApplicationButton/types';
import { TRedirectForAnalytics } from '../types';

export const calculateTypeOfRedirect = (type: TRedirectForAnalytics | null) => {
  switch (type) {
    case EFillApplicationStickyButtonType.TOP:
      return 'main';
    case EFillApplicationStickyButtonType.BOTTOM:
      return 'footer';
    default:
      return type;
  }
};
